import { render, staticRenderFns } from "./DepositBox.vue?vue&type=template&id=1a17d338&"
import script from "./DepositBox.vue?vue&type=script&lang=js&"
export * from "./DepositBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports